import { gql } from "@apollo/client";

export const GET_COMPANY_CATEGORIES_QUERY = gql`
  query GET_COMPANY_CATEGORIES_QUERY(
    $after: String
    $first: Int
    $search: String
    $sortBy: SortByInput
  ) {
    getCompanyCategories(
      after: $after
      first: $first
      search: $search
      sortBy: $sortBy
    ) {
      edges {
        node {
          _id
          name
          tags
          companies {
            _id
            fantasyName
            bgImg
            domain
            description
            color
          }
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export const GET_COMPANY_CATEGORY_QUERY = gql`
  query GET_COMPANY_CATEGORY_QUERY($_id: ID!) {
    getCompanyCategory(_id: $_id) {
      _id
      name
      img
      description
      tags
      companies {
        _id
        fantasyName
        logo
        domain
        description
        color
        bgImg
      }
    }
  }
`;
